import { stageRequirements } from '@/components/Property/propertyCardConstants';
import type { PropertyView } from '@/types/PropertyView';

const NEGOTIATION_CONTRACT_STATUSES = new Set([
  'draft',
  'negotiating',
  'repair_negotiating',
  'awaiting_signatures',
  'awaiting_buyer_signature',
  'awaiting_seller_signature',
]);

export function normalizeContractStatus(status?: string): string {
  return (status || '').toLowerCase().replace(/\s+/g, '_');
}

export function isNegotiationContractStatus(status?: string): boolean {
  return NEGOTIATION_CONTRACT_STATUSES.has(normalizeContractStatus(status));
}

/** Show header Dashboard when the deal needs attention (negotiation or stage work). */
export function propertyNeedsHeaderDashboard(
  property: PropertyView,
  contractStatus?: string
): boolean {
  if (property.stage === 6) return true;

  if (
    property.offerStatus === 'pending' ||
    property.offerStatus === 'countered'
  ) {
    return true;
  }

  if (isNegotiationContractStatus(contractStatus)) return true;

  const requirement = stageRequirements(property);
  if (!requirement.satisfied) return true;

  return false;
}

export function sellerDashboardUrl(
  productId: string,
  property?: PropertyView
): string {
  const stage = property?.stage ?? 1;
  return `/properties/${productId}/stage/${stage}`;
}

export function buyerDashboardUrl(
  productId: string,
  property?: PropertyView
): string {
  if (property?.stage === 6) return `/properties/${productId}/stage/6`;
  if (property?.stage === 5 && property.contractId) {
    return `/properties/${productId}/stage/5`;
  }
  return `/properties/${productId}/stage/7`;
}
